// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"812":"727973242bb33abd","2888":"e4e266b2d89b2926","4073":"37a624a8a2f74103","6685":"cc006d79c9642749"}[chunkId] + ".css";
};